import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';

interface PaymentOption {
  term: number;
  monthly_payment: number;
  apr: number;
  down_payment: number;
  type?: 'finance' | 'lease';
}

interface VehiclePaymentModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  vehicleInfo?: {
    year?: number | string;
    make?: string;
    model?: string;
    trim?: string;
  };
  payments?: PaymentOption[];
}

export const VehiclePaymentModal: React.FC<VehiclePaymentModalProps> = ({
  open,
  onOpenChange,
  vehicleInfo,
  payments,
}) => {
  if (!payments || payments.length === 0) {
    return null;
  }

  const vehicleTitle = vehicleInfo
    ? `${vehicleInfo.year} ${vehicleInfo.make} ${vehicleInfo.model}${vehicleInfo.trim ? ` ${vehicleInfo.trim}` : ''}`
    : 'Vehicle';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Payment Options - {vehicleTitle}</DialogTitle>
          <DialogDescription>
            Available financing terms for this vehicle
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="max-h-[60vh]">
          <div className="space-y-4">
            {payments.map((payment, idx) => (
              <div
                key={idx}
                className="border rounded-lg p-4 hover:bg-accent/50 transition-colors"
              >
                {payment.type && (
                  <div className="mb-2">
                    <span className="text-xs font-semibold uppercase px-2 py-1 rounded bg-primary/10 text-primary">
                      {payment.type}
                    </span>
                  </div>
                )}
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm text-muted-foreground">Term</p>
                    <p className="text-lg font-semibold">{payment.term} months</p>
                  </div>
                  <div>
                    <p className="text-sm text-muted-foreground">Monthly Payment</p>
                    <p className="text-lg font-semibold text-primary">
                      ${payment.monthly_payment.toFixed(2)}/mo
                    </p>
                  </div>
                  <div>
                    <p className="text-sm text-muted-foreground">APR</p>
                    <p className="text-lg font-semibold">{payment.apr}%</p>
                  </div>
                  {payment.down_payment > 0 && (
                    <div>
                      <p className="text-sm text-muted-foreground">Down Payment</p>
                      <p className="text-lg font-semibold">
                        ${payment.down_payment.toLocaleString()}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
